export function useOfflineFallbackPage() {
    window.addEventListener("load", () => {
        if ("serviceWorker" in navigator) {
            console.log("Registering offline fallback page service worker.");
            return navigator.serviceWorker.register(
                "./offline-fallback-page.js"
            );
        }

        console.warn(
            "Could not register offline fallback page service worker."
        );
    });
}
